import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import './RecentSearch.css';

const RecentSearches = ({ onRecentBox }) => {
  const [recentSearches, setRecentSearches] = useState([]);
  useEffect(() => {
    const recentBoxes = JSON.parse(localStorage.getItem('recentBoxes')) || [];
    const recentArray = [];
    recentBoxes?.length &&
      recentBoxes.map(box => {
        const backToUTF8 = JSON.parse(Buffer.from(box, 'base64').toString('utf8'));
        recentArray.push(backToUTF8);
      });
    setRecentSearches(recentArray);
  }, []);

  return (
    <>
      {recentSearches?.length ? (
        recentSearches?.map(box => {
          return (
            <Row key={box.id}>
              <Col sm="12">
                <Button className="recent-box" onClick={() => onRecentBox(box)}>
                  <p className="display-text">{box.displayName}</p>
                  <p className="display-text">{box.serialNumber}</p>
                </Button>
              </Col>
            </Row>
          );
        })
      ) : (
        <Row>
          <Col sm="12">
            <p className="display-text">No recent searches</p>
          </Col>
        </Row>
      )}
    </>
  );
};

export default RecentSearches;
